import React from 'react'

import { Body1, Title1 } from '@ui/Typography/Typography'

export const ModalBodyColumns = ({ columns }: { columns: { title: string; text: string }[] }) => (
  <div>
    {columns.map((column, i) => (
      <div key={i}>
        <Title1 medium color='text-med-em'>
          {column.title}
        </Title1>
        <Body1 color='text-med-em'>{column.text}</Body1>
      </div>
    ))}
  </div>
)
